import ThemedSpinner from "#/components/shared/spinner";
import Typography from "#/components/shared/typography";
import { MedicalRecordRequestsProvider } from "#/medical-record-requests/context/MedicalRecordRequestsContext";
import MedicalRecordRequestsLayout from "#/medical-record-requests/components/MedicalRecordRequestsLayout";
import { useUserDetails } from "#/hooks/useUserDetails";

export default function MedicalRecordsAdminRequestsPage() {
  const { userDetails, isLoading, error } = useUserDetails();
  const isAdmin = userDetails?.type === "admin";

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <ThemedSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 min-h-[40vh]">
        <Typography variant="h4" className="text-terracotta">
          Unable to verify your permissions
        </Typography>
        <Typography variant="body1" className="text-terracotta/80">
          {error instanceof Error ? error.message : "Please try again later."}
        </Typography>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[40vh] gap-2">
        <Typography variant="h4" className="text-terracotta">
          Admin access required
        </Typography>
        <Typography variant="body2" className="text-terracotta/80">
          You must be an administrator to view this page.
        </Typography>
      </div>
    );
  }

  return (
    <MedicalRecordRequestsProvider>
      <MedicalRecordRequestsLayout />
    </MedicalRecordRequestsProvider>
  );
}
